import { Action, createBrowserHistory, createMemoryHistory } from 'history';

import gtmHelper from '^utils/gtmHelper';
import { scrollToWidget } from '^utils/widgetActions';

// history v5: createMemoryHistory in widget (iframe) mode, createBrowserHistory standalone.
// Selection preserved from the legacy implementation (driven by window.xprops.isWidgetMode).
const sharedHistory = window.xprops.isWidgetMode ? createMemoryHistory() : createBrowserHistory();

// Side-effects preserved verbatim from the legacy listen() (R9):
//  - emit a GTM page view on every navigation
//  - auto-scroll the widget into view, EXCEPT on REPLACE navigations
// history v5 delivers a single { action, location } update object (v4 passed two args).
sharedHistory.listen(({ location, action }): void => {
  gtmHelper.emitPageView(location.pathname);

  if (action !== Action.Replace) {
    void scrollToWidget();
  }
});

export default sharedHistory;
